/** Selected backend, not build mode or frontend hostname, controls temporary rollout diagnostics. */
export function mobileOfferDebugOrigin(baseUrl: string | undefined, pageOrigin: string): string | undefined {
    try {
        const backend = new URL(baseUrl || '/', pageOrigin)
        if (backend.username || backend.password) return undefined
        if (backend.origin === 'https://dev-api.numeo.ai') return backend.origin
        if (['http:', 'https:'].includes(backend.protocol) && ['localhost', '127.0.0.1', '[::1]'].includes(backend.hostname)) return backend.origin
    } catch {
        // An invalid or unknown backend never enables diagnostics.
    }
    return undefined
}

/** Emit only recognized route templates. Never include identities, queries or arbitrary paths. */
export function mobileOfferDebugRoute(path: string): string {
    const pathname = path.split(/[?#]/, 1)[0]
    const fixedRoutes = [
        '/catalog/v1',
        '/capabilities/v1',
        '/preview/v1',
        '/provision/v1',
        '/provision/status/v1',
        '/apple/code-batches/v1',
        '/customers/lookup/v1',
        '/assignments/v1',
        '/assignments/readiness/v1',
    ]
    if (fixedRoutes.includes(pathname)) return pathname
    if (/^\/customers\/[^/]+\/assignments\/v1$/.test(pathname)) return '/customers/:userId/assignments/v1'
    if (/^\/customers\/[^/]+\/v1$/.test(pathname)) return '/customers/:userId/v1'
    if (/^\/assignments\/[^/]+\/revoke\/v1$/.test(pathname)) return '/assignments/:id/revoke/v1'
    if (/^\/assignments\/[^/]+\/reassign\/v1$/.test(pathname)) return '/assignments/:id/reassign/v1'
    if (/^\/assignments\/[^/]+\/reassign\/readiness\/v1$/.test(pathname)) return '/assignments/:id/reassign/readiness/v1'
    if (/^\/catalog\/[^/]+\/v1$/.test(pathname)) return '/catalog/:id/v1'
    return '/unrecognized-route'
}
